export const CALLBACK_WAIT_MS = 200
